import React from "react";
import { Link } from "react-router-dom";

export default function Pagination({
  postsPerPage,
  totalPosts,
  paginateFront,
  paginateBack,
  currentPage,
}) {
  return (
    <div className="py-2">
      <div className="ml-2 ">
        <p className="text-sm text-green-600 screen500:text-[12px]">
          نمایش
          <span className="font-medium mx-1 screen500:text-[12px]">
            {currentPage * postsPerPage - (postsPerPage - 1)}
          </span>
          تا
          <span className="font-medium mx-1 screen500:text-[12px]">
            {currentPage * postsPerPage < totalPosts
              ? currentPage * postsPerPage
              : totalPosts}
          </span>
          از
          <span className="font-medium mx-1 screen500:text-[12px]">
            {totalPosts}
          </span>
          نتیجه
        </p>
      </div>
      <nav className="block" />
      <div>
        <nav
          className=" z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <Link
            onClick={() => {
              paginateBack();
            }}
            to="#"
            className={` inline-flex items-center px-6 py-2 caret-transparent  screen500:py-1 screen500:px-4  screen500:text-[12px]  font-semibold
            rounded-l-md border border-gray-300 bg-white text-sm  text-green-600 hover:bg-gray-200 
            ${
              currentPage * postsPerPage - (postsPerPage - 1) <= 1 &&
              "pointer-events-none text-gray-400"
            }
            `}
          >
            <span>قبلی</span>
          </Link>

          <Link
            onClick={() => {
              paginateFront();
            }}
            to="#"
            className={` inline-flex items-center px-6 py-2 caret-transparent rounded-r-md border screen500:py-1 font-semibold screen500:px-4 screen500:text-[12px]
             border-gray-300 bg-white text-sm  text-green-600 hover:bg-gray-200
             ${
               currentPage * postsPerPage >= totalPosts &&
               "pointer-events-none text-gray-400"
             }
             `}
          >
            <span>بعدی</span>
          </Link>
        </nav>
      </div>
    </div>
  );
}
